/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Upgrade_NowInputs */

const en_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Now`)
};

const ar_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترقية الآن`)
};

const de_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt upgraden`)
};

const es_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar ahora`)
};

const fr_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à niveau`)
};

const it_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna ora`)
};

const ja_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐアップグレード`)
};

const ko_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 업그레이드`)
};

const pt_br_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar agora`)
};

const ru_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить сейчас`)
};

const th_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเกรดทันที`)
};

const tr_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi Yükselt`)
};

const zh_cn_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即升级`)
};

const zh_tw_btn_upgrade_now = /** @type {(inputs: Btn_Upgrade_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即升級`)
};

/**
* | output |
* | --- |
* | "Upgrade Now" |
*
* @param {Btn_Upgrade_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_upgrade_now = /** @type {((inputs?: Btn_Upgrade_NowInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Upgrade_NowInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_upgrade_now(inputs)
	if (locale === "ar") return ar_btn_upgrade_now(inputs)
	if (locale === "de") return de_btn_upgrade_now(inputs)
	if (locale === "es") return es_btn_upgrade_now(inputs)
	if (locale === "fr") return fr_btn_upgrade_now(inputs)
	if (locale === "it") return it_btn_upgrade_now(inputs)
	if (locale === "ja") return ja_btn_upgrade_now(inputs)
	if (locale === "ko") return ko_btn_upgrade_now(inputs)
	if (locale === "pt_br") return pt_br_btn_upgrade_now(inputs)
	if (locale === "ru") return ru_btn_upgrade_now(inputs)
	if (locale === "th") return th_btn_upgrade_now(inputs)
	if (locale === "tr") return tr_btn_upgrade_now(inputs)
	if (locale === "zh_cn") return zh_cn_btn_upgrade_now(inputs)
	return zh_tw_btn_upgrade_now(inputs)
});